/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { portfoliosApi } from 'services/newApi/portfoliosApi';
import { PortfolioResponse } from 'services/types';

export interface PortfoliosState {
  portfoliosList: PortfolioResponse[];
}

const initialState: PortfoliosState = {
  portfoliosList: [],
};

export const portfoliosSlice: Slice<PortfoliosState> = createSlice({
  name: 'portfoliosSlice',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addMatcher(
      portfoliosApi.endpoints.getPortfoliosList.matchFulfilled,
      (state, action: PayloadAction<PortfolioResponse[]>) => {
        if (action.payload.length > 0) {
          state.portfoliosList = action.payload;
        }
      }
    );
  },
});

export const { updateSelectedMetricId } = portfoliosSlice.actions;
